export default {
    NEXTGEN: 'NextGen',
    RETAIL_OPERATOR: 'Retail Operator',
};
